import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
    ApiService,
    Mk2Request,
    Mk2Response,
    Pagination
} from '@lsq-frontend/angular-shared/api-service';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { AdminManageBuyerImplementationFboConfigurationDto } from '../../model/admin-manage-buyer-implementation-fbo-configuration-dto';
import { AdminManageBuyerPayLaterConfigurationDto } from '../../model/admin-manage-buyer-pay-later-configuration-dto';

export class GetBuyerImplementationConfigurationRequest extends Mk2Request {
    buyerImplementationKey?: string;

    constructor(initial?: Partial<GetBuyerImplementationConfigurationRequest>) {
        super();
        if (initial != null) {
            Object.keys(initial).forEach((key) => {
                this[key] = initial[key];
            });
        }
    }
}

export class GetBuyerImplementationConfigurationResponse extends Mk2Response {
    accountBuyerPaidFeePercentage?: number;
    accountBuyerPaidFeePercentageVisible?: boolean;
    accountBuyerPaidTransactionFee?: boolean;
    accountBuyerPaidTransactionFeeVisible?: boolean;
    accountCreditLimitCents?: number;
    accountCreditLimitCurrencyCode?:
        | 'UNKNOWN_CURRENCY_CODE'
        | 'AED'
        | 'AFN'
        | 'ALL'
        | 'AMD'
        | 'ANG'
        | 'AOA'
        | 'ARS'
        | 'AUD'
        | 'AWG'
        | 'AZN'
        | 'BAM'
        | 'BBD'
        | 'BDT'
        | 'BGN'
        | 'BHD'
        | 'BIF'
        | 'BMD'
        | 'BND'
        | 'BOB'
        | 'BOV'
        | 'BRL'
        | 'BSD'
        | 'BTN'
        | 'BWP'
        | 'BYR'
        | 'BZD'
        | 'CAD'
        | 'CDF'
        | 'CHE'
        | 'CHF'
        | 'CHW'
        | 'CLF'
        | 'CLP'
        | 'CNY'
        | 'COP'
        | 'COU'
        | 'CRC'
        | 'CUC'
        | 'CUP'
        | 'CVE'
        | 'CZK'
        | 'DJF'
        | 'DKK'
        | 'DOP'
        | 'DZD'
        | 'EGP'
        | 'ERN'
        | 'ETB'
        | 'EUR'
        | 'FJD'
        | 'FKP'
        | 'GBP'
        | 'GEL'
        | 'GHS'
        | 'GIP'
        | 'GMD'
        | 'GNF'
        | 'GTQ'
        | 'GYD'
        | 'HKD'
        | 'HNL'
        | 'HRK'
        | 'HTG'
        | 'HUF'
        | 'IDR'
        | 'ILS'
        | 'INR'
        | 'IQD'
        | 'IRR'
        | 'ISK'
        | 'JMD'
        | 'JOD'
        | 'JPY'
        | 'KES'
        | 'KGS'
        | 'KHR'
        | 'KMF'
        | 'KPW'
        | 'KRW'
        | 'KWD'
        | 'KYD'
        | 'KZT'
        | 'LAK'
        | 'LBP'
        | 'LKR'
        | 'LRD'
        | 'LSL'
        | 'LYD'
        | 'MAD'
        | 'MDL'
        | 'MGA'
        | 'MKD'
        | 'MMK'
        | 'MNT'
        | 'MOP'
        | 'MRU'
        | 'MUR'
        | 'MVR'
        | 'MWK'
        | 'MXN'
        | 'MXV'
        | 'MYR'
        | 'MZN'
        | 'NAD'
        | 'NGN'
        | 'NIO'
        | 'NOK'
        | 'NPR'
        | 'NZD'
        | 'OMR'
        | 'PAB'
        | 'PEN'
        | 'PGK'
        | 'PHP'
        | 'PKR'
        | 'PLN'
        | 'PYG'
        | 'QAR'
        | 'RON'
        | 'RSD'
        | 'RUB'
        | 'RWF'
        | 'SAR'
        | 'SBD'
        | 'SCR'
        | 'SDG'
        | 'SEK'
        | 'SGD'
        | 'SHP'
        | 'SLL'
        | 'SOS'
        | 'SRD'
        | 'SSP'
        | 'STN'
        | 'SVC'
        | 'SYP'
        | 'SZL'
        | 'THB'
        | 'TJS'
        | 'TMT'
        | 'TND'
        | 'TOP'
        | 'TRY'
        | 'TTD'
        | 'TWD'
        | 'TZS'
        | 'UAH'
        | 'UGX'
        | 'USD'
        | 'USN'
        | 'UYI'
        | 'UYU'
        | 'UZS'
        | 'VEF'
        | 'VND'
        | 'VUV'
        | 'WST'
        | 'XAF'
        | 'XCD'
        | 'XDR'
        | 'XOF'
        | 'XPF'
        | 'XSU'
        | 'XUA'
        | 'YER'
        | 'ZAR'
        | 'ZMW'
        | 'ZWL'
        | 'UNRECOGNIZED';
    accountDecayingFeeRatePercent?: number;
    accountDefaultFlatFeeRatePercent?: number;
    accountGracePeriodDays?: number;
    accountIngestAllInvoices?: boolean;
    accountInforNexusEnabled?: boolean;
    accountFundingDateIneligibleDaysBeforeTerms?: number;
    accountIneligibleDaysBeforeTerms?: number;
    accountInvoiceMaximumDaysPaidEarly?: number;
    accountLsqRevenueSharePercent?: number;
    accountMaxFundableInvoiceAgeDays?: number;
    accountPastDueFeePercent?: number;
    accountPlatformRevenueSharePercent?: number;
    accountPrimaryBuyerRevenueSharePercent?: number;
    accountPrimaryDueDateThreshold?: number;
    accountSecondaryBuyerRevenueSharePercent?: number;
    accountSecondaryDueDateThreshold?: number;
    bankAccountBankName?: string;
    bankAccountName?: string;
    bankAccountNumberLastFour?: string;
    bankAccountRoutingNumberLastFour?: string;
    buyerCreditLimitCents?: number;
    buyerCreditLimitCurrencyCode?:
        | 'UNKNOWN_CURRENCY_CODE'
        | 'AED'
        | 'AFN'
        | 'ALL'
        | 'AMD'
        | 'ANG'
        | 'AOA'
        | 'ARS'
        | 'AUD'
        | 'AWG'
        | 'AZN'
        | 'BAM'
        | 'BBD'
        | 'BDT'
        | 'BGN'
        | 'BHD'
        | 'BIF'
        | 'BMD'
        | 'BND'
        | 'BOB'
        | 'BOV'
        | 'BRL'
        | 'BSD'
        | 'BTN'
        | 'BWP'
        | 'BYR'
        | 'BZD'
        | 'CAD'
        | 'CDF'
        | 'CHE'
        | 'CHF'
        | 'CHW'
        | 'CLF'
        | 'CLP'
        | 'CNY'
        | 'COP'
        | 'COU'
        | 'CRC'
        | 'CUC'
        | 'CUP'
        | 'CVE'
        | 'CZK'
        | 'DJF'
        | 'DKK'
        | 'DOP'
        | 'DZD'
        | 'EGP'
        | 'ERN'
        | 'ETB'
        | 'EUR'
        | 'FJD'
        | 'FKP'
        | 'GBP'
        | 'GEL'
        | 'GHS'
        | 'GIP'
        | 'GMD'
        | 'GNF'
        | 'GTQ'
        | 'GYD'
        | 'HKD'
        | 'HNL'
        | 'HRK'
        | 'HTG'
        | 'HUF'
        | 'IDR'
        | 'ILS'
        | 'INR'
        | 'IQD'
        | 'IRR'
        | 'ISK'
        | 'JMD'
        | 'JOD'
        | 'JPY'
        | 'KES'
        | 'KGS'
        | 'KHR'
        | 'KMF'
        | 'KPW'
        | 'KRW'
        | 'KWD'
        | 'KYD'
        | 'KZT'
        | 'LAK'
        | 'LBP'
        | 'LKR'
        | 'LRD'
        | 'LSL'
        | 'LYD'
        | 'MAD'
        | 'MDL'
        | 'MGA'
        | 'MKD'
        | 'MMK'
        | 'MNT'
        | 'MOP'
        | 'MRU'
        | 'MUR'
        | 'MVR'
        | 'MWK'
        | 'MXN'
        | 'MXV'
        | 'MYR'
        | 'MZN'
        | 'NAD'
        | 'NGN'
        | 'NIO'
        | 'NOK'
        | 'NPR'
        | 'NZD'
        | 'OMR'
        | 'PAB'
        | 'PEN'
        | 'PGK'
        | 'PHP'
        | 'PKR'
        | 'PLN'
        | 'PYG'
        | 'QAR'
        | 'RON'
        | 'RSD'
        | 'RUB'
        | 'RWF'
        | 'SAR'
        | 'SBD'
        | 'SCR'
        | 'SDG'
        | 'SEK'
        | 'SGD'
        | 'SHP'
        | 'SLL'
        | 'SOS'
        | 'SRD'
        | 'SSP'
        | 'STN'
        | 'SVC'
        | 'SYP'
        | 'SZL'
        | 'THB'
        | 'TJS'
        | 'TMT'
        | 'TND'
        | 'TOP'
        | 'TRY'
        | 'TTD'
        | 'TWD'
        | 'TZS'
        | 'UAH'
        | 'UGX'
        | 'USD'
        | 'USN'
        | 'UYI'
        | 'UYU'
        | 'UZS'
        | 'VEF'
        | 'VND'
        | 'VUV'
        | 'WST'
        | 'XAF'
        | 'XCD'
        | 'XDR'
        | 'XOF'
        | 'XPF'
        | 'XSU'
        | 'XUA'
        | 'YER'
        | 'ZAR'
        | 'ZMW'
        | 'ZWL'
        | 'UNRECOGNIZED';
    buyerDecayingFeeRatePercent?: number;
    buyerDefaultFlatFeeRatePercent?: number;
    buyerGracePeriodDays?: number;
    buyerIngestAllInvoices?: boolean;
    buyerInforNexusEnabled?: boolean;
    buyerFundingDateIneligibleDaysBeforeTerms?: number;
    buyerIneligibleDaysBeforeTerms?: number;
    buyerInvoiceMaximumDaysPaidEarly?: number;
    buyerLsqRevenueSharePercent?: number;
    buyerMaxFundableInvoiceAgeDays?: number;
    buyerPaidFeePercentage?: number;
    buyerPaidFeePercentageVisible?: boolean;
    buyerPaidTransactionFee?: boolean;
    buyerPaidTransactionFeeVisible?: boolean;
    buyerPastDueFeePercent?: number;
    buyerPlatformRevenueSharePercent?: number;
    buyerPrimaryBuyerRevenueSharePercent?: number;
    buyerPrimaryDueDateThreshold?: number;
    buyerSecondaryBuyerRevenueSharePercent?: number;
    buyerSecondaryDueDateThreshold?: number;
    fboConfiguration?: AdminManageBuyerImplementationFboConfigurationDto;
    payLaterConfiguration?: AdminManageBuyerPayLaterConfigurationDto;

    constructor(initial?: Partial<GetBuyerImplementationConfigurationResponse>) {
        super();
        if (initial != null) {
            Object.keys(initial).forEach((key) => {
                this[key] = initial[key];
            });
        }
    }
}

@Injectable({ providedIn: 'root' })
export class GetBuyerImplementationConfigurationService extends ApiService<
    GetBuyerImplementationConfigurationRequest,
    GetBuyerImplementationConfigurationResponse
> {
    public requestType = GetBuyerImplementationConfigurationRequest;
    public responseType = GetBuyerImplementationConfigurationResponse;
    public endpointName =
        'operations/AdminManageBuyerImplementation/GetBuyerImplementationConfiguration';
    public serviceName = 'financing';
    constructor(http: HttpClient, @Inject(SETTINGS) settings: ISettings) {
        super(http, settings);
    }
}
